import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";


export class vnAppZoneMenu extends vnAppZone {

    public constructor(destination, appInterface: string | null = null) {
        super(destination, appInterface);
        this.zoneName = "Menu";
    }

    defineRoutes(appInterface) {

        let factory = new pageFactory();
        let _mythis = this;
        //define routes

        this.addForRoute('all', function () {

            // obtain the right module object
            let moduleObj = factory.get_actionHandler("menu", _mythis);

            // load it into the zone
            _mythis.loadModule(moduleObj);
        }, null);

        this.addForRoute('/menu', function () {}, null);
    }
}




// WEBPACK FOOTER //
// ./js/components/vn_app_zone_menu.ts